import module from 'recursoshumanos/module.js'

const schema = {}

export class RecursoshumanosDictamenPuestos {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa, periodo, descarga) {
    return this.$http.get('/api/recursos_humanos/dictamen/puestos', {
      params: {id_empresa: idEmpresa, periodo, descarga},
      download: !!descarga,
      schema,
    })
  }
}

module.service('RecursoshumanosDictamenPuestos', RecursoshumanosDictamenPuestos)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/Dictamen/Puestos.js